
/* injects from baggage-loader */

'use strict';

import campaignTemplate from '!!file-loader?name=templates/[name].[ext]!./campaign.html';

/**
* Function that register the all routes for the view campaign module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the view campaign page.
	*/
	const indexNav = 0;
	const campaignRoute = {
		state: navigationConstant.RESOURCES[indexNav].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].URL,
			templateUrl: campaignTemplate,
			controller: 'CampaignController',
			controllerAs: 'campaignvm',
			resolve: {
				campaign: campaignLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].NAME,
				submenu: false
			},
		}
	}

	routerHelper.configureStates([campaignRoute]);
}

/**
* Function for the lazyLoading configuration in the view campaign route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function campaignLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const campaignModule = require('./campaign.module');

		$ocLazyLoad.load({
			name: campaignModule.default.name,
		});

		deferred.resolve(campaignModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('campaign.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/management/campaign/campaign.routes.js